import { AttivazionePrivacyConsents } from './../../../models/attivazione';
import { Component, OnInit, ViewContainerRef, OnChanges, SimpleChanges, EventEmitter, Output, OnDestroy, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { ModalDialogService } from 'ngx-modal-dialog';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { Privacy } from './../../../models/privacy';
import { ApiService } from '../../../services/api.service';
import { AlgCfModalComponent } from '../../dialogs/alg-cf-modal/alg-cf-modal.component';
import { AlgPrivacyModalComponent } from '../../dialogs/alg-privacy-modal/alg-privacy-modal.component';
import { UtilsService } from '../../../services/utils.service';
import { AlgAttivazioniService } from '../../../services/alg-attivazioni.service';
import { AlgGtmService } from '../../../services/alg-gtm.service';

const privacyData = require('../../../data/newPrivacy.json');

@Component({
  selector: 'alg-attivazioni-personal-data',
  templateUrl: './alg-attivazioni-personal-data.component.html',
  styleUrls: ['./alg-attivazioni-personal-data.component.scss'],
})
export class AlgAttivazioniPersonalDataComponent implements OnInit, OnDestroy {
  public isProductPlacet: boolean;
  public isProductVulnerable: boolean;
  public informativeNoteUrl = '';
  public privacyForm: FormGroup;
  public readAcceptances = {
    privacy: false,
    commercialiALG: false,
    commercialiTerzi: false,
    profilazioneALG: false,
    profilazioneTerzi: false,
    qualità: false,
    docsReception: false,
  };
  public variablesPrivacyCondition = {
    privacy: false,
    commercialiALG: false,
    commercialiTerzi: false,
    profilazioneALG: false,
    profilazioneTerzi: false,
    qualità: false,
    docsReception: false,
  };

  public privacyOptions = [
    {
      label: 'Do il consenso',
      value: 'true',
    },
    {
      label: 'Nego il consenso',
      value: 'false',
    },
  ];

  public privacyItems: any;

  public variablePrivacy = {
    commercialiALG: {
      value: '',
    },
    commercialiTerzi: {
      value: '',
    },
    profilazioneALG: {
      value: '',
    },
    profilazioneTerzi: {
      value: '',
    },
    qualità: {
      value: '',
    },
  };
  private ngUnsubscribe = new Subject<void>();
  private privacyFieldsMap = new Map([
    ['commercialiALG', 'privacyComCom'],
    ['profilazioneALG', 'privacyProf'],
    ['qualità', 'privacyQualServ'],
    ['commercialiTerzi', 'privacyComTer'],
    ['profilazioneTerzi', 'privacyProfTer'],
    ['docsReception', 'docsReception'],
  ]);
  private mappedData: any = null;

  public privacyMapper = {
    privacyComCom: false,
    privacyProf: false,
    privacyQualServ: false,
    privacyComTer: false,
    privacyProfTer: false,
    docsReception: false,
  };

  constructor(
    private consensoSerivce: AlgAttivazioniService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef,
    private gtm: AlgGtmService
  ) {}

  checkData(data) {
    console.log('data', data);
    this.mappedData = this.transformPrivacyConsents(data);
    this.mappedData.generalPrivacy = this.variablesPrivacyCondition.privacy;
    this.consensoSerivce.updatePrivacyConsents({
      valid: this.mappedData.generalPrivacy && this.mappedData.docsReception && this.privacyForm.status === 'VALID',
      data: this.mappedData,
    });
  }

  ngOnInit() {
    this.consensoSerivce.attivazione$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((attivazione) => {
      this.isProductVulnerable = attivazione.vulnerabilityType !== undefined;
      this.isProductPlacet = attivazione.product.family.toLowerCase() === 'placet';
    });

    // SUBSCRIBE: save general privacy policy url
    this.consensoSerivce.policiesUrl$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((policiesUrls) => {
      this.informativeNoteUrl = policiesUrls.generalPolicy;
    });

    this.privacyForm = new FormGroup({
      privacyCondition: new FormControl(this.variablesPrivacyCondition.privacy, {
        validators: [Validators.required],
      }),
      docsReception: new FormControl(this.variablesPrivacyCondition.docsReception, {
        validators: [Validators.required],
      }),
    });

    // this.privacyForm.valueChanges.subscribe(data => {
    //   this.checkData(data)
    // });

    this.privacyItems = Object.keys(privacyData)
      .filter(
        (key) => ['accendi'].indexOf(key) === -1
        // ['commercialiTerzi', 'profilazioneTerzi', 'accendi'].indexOf(key) === -1
      ) // HACK: removes it to re-eanble last two consents (leave only 'accendi')
      .slice(2)
      .map((e) => {
        privacyData[e]['id'] = e;
        return privacyData[e];
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  openModal(modalContent) {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: modalContent.title,
      childComponent: AlgPrivacyModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline',
      },
      data: {
        description: modalContent.description,
      },
    });
  }

  conditionClicked(type) {
    this.readAcceptances[type] = true;
  }

  changeCheckbox(event, checkbox) {
    switch (checkbox) {
      case 'privacy':
        console.log('privacy', this.variablesPrivacyCondition.privacy);
        this.variablesPrivacyCondition.privacy = !this.variablesPrivacyCondition.privacy;
        this.readAcceptances.privacy = true;
        this.checkData(this.variablesPrivacyCondition);
        break;

      case 'commercialiALG':
        this.variablesPrivacyCondition.commercialiALG = !this.variablesPrivacyCondition.commercialiALG;
        this.readAcceptances.commercialiALG = !this.readAcceptances.commercialiALG;
        this.checkData(this.variablesPrivacyCondition);
        break;

      case 'profilazioneALG':
        this.variablesPrivacyCondition.profilazioneALG = !this.variablesPrivacyCondition.profilazioneALG;
        this.readAcceptances.profilazioneALG = !this.readAcceptances.profilazioneALG;
        this.checkData(this.variablesPrivacyCondition);
        break;

      case 'qualità':
        this.variablesPrivacyCondition.qualità = !this.variablesPrivacyCondition.qualità;
        this.readAcceptances.qualità = !this.readAcceptances.qualità;
        this.checkData(this.variablesPrivacyCondition);
        break;

      case 'commercialiTerzi':
        this.variablesPrivacyCondition.commercialiTerzi = !this.variablesPrivacyCondition.commercialiTerzi;
        this.readAcceptances.commercialiTerzi = !this.readAcceptances.commercialiTerzi;
        this.checkData(this.variablesPrivacyCondition);
        break;

      case 'profilazioneTerzi':
        this.variablesPrivacyCondition.profilazioneTerzi = !this.variablesPrivacyCondition.profilazioneTerzi;
        this.readAcceptances.profilazioneTerzi = !this.readAcceptances.profilazioneTerzi;
        this.checkData(this.variablesPrivacyCondition);
        break;
      case 'docsReception':
        this.variablesPrivacyCondition.docsReception = !this.variablesPrivacyCondition.docsReception;
        this.readAcceptances.docsReception = true;
        this.checkData(this.variablesPrivacyCondition);
        break;
    }
  }

  public readPrivacy(type) {
    let modalContent;
    switch (type) {
      case 'commercialiALG':
        modalContent = Privacy('commercialiALG');
        break;
      case 'profilazioneALG':
        modalContent = Privacy('profilazioneALG');
        break;
      case 'qualità':
        modalContent = Privacy('qualità');
        break;
      case 'commercialiTerzi':
        modalContent = Privacy('commercialiTerzi');
        break;
      default:
        modalContent = Privacy('profilazioneTerzi');
    }
    this.openModal(modalContent || {});
  }

  private transformPrivacyConsents(consents): AttivazionePrivacyConsents {
    return Object.keys(consents || {}).reduce((acc, key) => {
      const mappedKey = this.privacyFieldsMap.get(key);
      if (!mappedKey) {
        return acc;
      }
      return {
        ...acc,
        [mappedKey]: consents[key],
      };
    }, {}) as AttivazionePrivacyConsents;
  }

  gtmPush(itemName, value) {
    return this.gtm.submitOnbEvent('Scelta consenso ' + itemName, value ? 'agree' : 'disagree');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alg-attivazioni/alg-attivazioni-personal-data/alg-attivazioni-personal-data.component.ts